import {NgModule} from '@angular/core';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';
import {ModalModule} from 'ngx-bootstrap/modal';
import {SelectModule} from 'ng-select';
import {EvsStampService} from '../../../../common/services/EvsStamp.service';
import {ModalDistributionComponent} from './modalDistribution.component';
import {ModalCancelStampComponent} from './modalCancelStamp.component';
import {CommonModule} from '@angular/common';
import {ModalActivePrintBatchComponent} from './modalActivePrintBatch.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ConfirmBatchStampComponent} from './confirm-batch-stamp/confirm-batch-stamp.component';
import {ModalDistribution2Component} from './modalDistribution2.component';
import {FilterProductsModule} from '../../../../layout/filter-products/filter-products.module';
import {ModalLockListStampComponent} from './modalLockListStamp/modalLockListStamp.component';
import {ModalDeleteStampComponent} from './confirmDeleteStamp/modalDeleteStamp.component';
import {ModalDeleteComponent} from './confirmDelete/modalDelete.component';
import { TranslateModule } from '@ngx-translate/core';
import { WarrantyReminderModule } from '../../../../common/components/warranty-reminder/warranty-reminder.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FilterProductsModule,
    ModalModule.forRoot(),
    SelectModule,
    BsDatepickerModule.forRoot(),
    TranslateModule,
    WarrantyReminderModule
  ],
  declarations: [
    ModalDistributionComponent,
    ModalCancelStampComponent,
    ModalLockListStampComponent,
    ModalActivePrintBatchComponent,
    ConfirmBatchStampComponent,
    ModalDistribution2Component,
    ModalDeleteStampComponent,
    ModalDeleteComponent
  ],
  providers: [ApiEvsService, EvsStampService],
  entryComponents: [
    ModalDistributionComponent,
    ModalCancelStampComponent,
    ModalLockListStampComponent,
    ModalActivePrintBatchComponent,
    ConfirmBatchStampComponent,
    ModalDistribution2Component,
    ModalDeleteStampComponent,
    ModalDeleteComponent
  ],
})
export class PopupModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/popup.module.ts